<template>
    <div >
        <!-- Header -->
        <students-page-tour :canShow="true" @finished="showTour = false" :start="showTour"></students-page-tour>

        <div class="py-3 mb-3 border-bottom " id="studentesPage">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-sm-6 d-flex">
                        <h5 class="m-0 p-0 align-self-center" >
                            <i class="fas fa-user-graduate mr-1"></i> Alunos
                        </h5>
                        <div @click="showTour = true" class="d-flex align-items-center text-primary" role="button" v-b-tooltip.hover title="Ver tutuorial">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 5.25h.008v.008H12v-.008Z" />
                              </svg>
                        </div>
                    </div>
                    <div class="col-12 col-sm-6 text-left text-sm-right d-flex justify-content-end">

                        <!-- Export -->
                        <b-button type="button" variant="outline-info" class="mr-3" @click="openExportStudent">
                            <i class="fas fa-file-export mr-1"></i>
                            Exportar Planilha
                        </b-button>
                        

                        <!-- Import -->
                        <b-button type="button" variant="outline-secondary" class="mr-3" @click="importMany">
                            <i class="fas fa-file-import mr-1"></i>
                            Importar Alunos
                        </b-button>

                        <!-- Create -->
                        <b-button id="createStudentsButtonTour" type="button" class="" @click="createStudent">
                            <i class="fas fa-plus mr-1"></i>
                            Adicionar Aluno
                        </b-button>

                    </div>
                </div>
            </div>
        </div>

        <!-- Container -->
        <div  class="container">

            <div class="row mb-2" v-if="limitStudents !== null">
                <div class="col-sm-4 mb-2">

                    <div class="card">
                        <div class="card-body">
                            <button type="button" class="close text-dark" v-b-tooltip.hover title="Quantidade de alunos ativos na organização">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" height="1.25rem">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
                                </svg>
                            </button>
                            <div class="d-flex gap-3 align-items-center" style="">
                                <div class="rounded-circle p-2" style="background-color: #ffeba9b0;"  >
                                    <svg style=" color: #c26e00;" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" height="2rem">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" />
                                    </svg>
                                </div>
                                <div class="lh-sm">
                                    <div class="fs-4"><b>{{ countStudents }}</b></div>
                                    <div>Alunos</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-4 mb-2">

                    <div class="card">
                        <div class="card-body">
                            <button type="button" class="close text-dark" v-b-tooltip.hover title="Quantidade de alunos bloqueados na organização">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" height="1.25rem">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
                                </svg>
                            </button>
                            <div class="d-flex gap-3 align-items-center" style="">
                                <div class="rounded-circle p-2" style="background-color: #ffa9a9b0;">
                                    <svg style=" color: #c20000;" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" height="2rem" width="2rem">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636" />
                                    </svg>
                                </div>
    
                                <div class="lh-sm">
                                    <div class="fs-4"><b>{{ blockedStudents }}</b></div>
                                    <div>Alunos bloqueados</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-4 mb-2">

                    <div class="card">
                        <div class="card-body">
                            <a type="button" :href='endpointSignature' class="close text-dark" v-b-tooltip.hover title="Ir para assinatura">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" height="1.25rem">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 002.25-2.25V6.75A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25v10.5A2.25 2.25 0 004.5 19.5z" />
                                  </svg>                                  
                            </a>
                            <div class="d-flex gap-3 align-items-center" style="">
                                <div class="rounded-circle p-2" style="background-color: #007bc260;"  >
                                    <svg style=" color: #007bc2;" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" height="2rem">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" />
                                    </svg>
                                </div>
                                <div class="lh-sm">
                                    <div class="fs-4"><b>{{ limitStudents }}</b></div>
                                    <div>Limite de Alunos</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!--

                    <b-alert show :variant="(limitStudents - countStudents) < 5 ? 'danger' : 'info'">
                        Utilizando <b>{{ countStudents }}</b> de <b>{{ limitStudents }}</b> alunos disponibilizados nessa escola/organização.
                        <span v-if="integrationStripe">
                            <a class="button" :href='endpointSignature' style="text-decoration:none">
                                    <b-button variant="outline-primary" size="sm">Alterar plano</b-button>
                            </a>
    
                        </span>
                    </b-alert>
                -->
            </div>

            <!-- Filters -->
            <div class="row mb-2" id="studentsFilterTour">
                <div class="col-sm-4" v-if="matriculation">
                    <!-- Field -->
                    <b-form-group label="Matrícula">
                        <b-form-input
                            v-model="filter.matriculation"
                            placeholder="Buscar por matrícula ..."
                            debounce="500"
                        ></b-form-input>
                    </b-form-group>
                </div>
                <div class="col-sm-4">
                    <!-- Field -->
                    <b-form-group label="Nome">
                        <b-form-input
                            v-model="filter.name"
                            placeholder="Buscar por nome ..."
                            debounce="500"
                        ></b-form-input>
                    </b-form-group>
                </div>
                <div class="col-sm-4">
                    <!-- Field -->
                    <b-form-group label="Email">
                        <b-form-input
                            v-model="filter.email"
                            placeholder="Buscar por email ..."
                            debounce="500"
                        ></b-form-input>
                    </b-form-group>
                </div>
                <div class="col-sm-4">
                    <!-- Field -->
                    <b-form-group label="Telefone">
                        <b-form-input
                            v-model="filter.phone"
                            placeholder="Buscar por telefone ..."
                            debounce="500"
                        ></b-form-input>
                    </b-form-group>
                </div>
                <div class="col-sm-4">
                    <!-- Field -->
                    <b-form-group label="Turmas">
                        <multiselect
                            v-model="filter.groups"
                            :options="groups"
                            :taggable="true"
                            :multiple="true"
                            :loading="loading"
                            track-by="id"
                            label="name"
                            placeholder="Buscar por Turma ..."
                            tag-placeholder="Filtrar Turma"
                            selectLabel="Selecionar"
                            deselectLabel="Desmarcar"
                            selectedLabel="Selecionado">

                            <span slot="noResult">
                                Ops! Nenhum resultado encontrado na pesquisa :(
                            </span>

                            <span slot="noOptions">
                                Não há turmas disponíveis para exibir :(
                            </span>

                        </multiselect>
                    </b-form-group>
                </div>
                <div class="col-sm-4">
                    <!-- Field -->
                    <b-form-group label="Bloqueados">
                        <multiselect
                            v-model="filter.blockeds"
                            :options="blockeds"
                            :loading="loading"
                            track-by="id"
                            label="name"
                            placeholder="Filtrar Bloqueados"
                            tag-placeholder="Filtrar Bloqueados"
                            selectLabel="Selecionar"
                            deselectLabel="Desmarcar"
                            selectedLabel="Selecionado">

                                <span slot="noResult">
                                    Ops! Nenhum resultado encontrado na pesquisa :(
                                </span>

                                <span slot="noOptions">
                                    Não há status para exibir :(
                                </span>
                        </multiselect>
                    </b-form-group>
                </div>
                <div class="col-sm-4">
                    <b-form-group label="Data de Vencimento (Créditos)">
                        <div class="d-flex">
                            <date-range-picker
                                ref="picker"
                                opens="right"
                                v-model="filter.dueDate"
                                :show-dropdowns="true"
                                :append-to-body="true"
                                :ranges="false"
                                :autoApply="true"
                                :locale-data="localeData"
                                locale="pt-BR"
                                control-container-class="form-control"
                            >
                                <template v-slot:input="picker">
                                    <i class="fas fa-calendar mr-1"></i> {{ picker.startDate | moment('DD MMMM YYYY') }} - {{ picker.endDate | moment('DD MMMM YYYY') }}
                                </template>
                            </date-range-picker>
                            <b-button type="button" variant="light" class="bg-white" v-if="filter.dueDate.startDate && filter.dueDate.endDate" @click="clearDueDate">
                                <i class="fas fa-times"></i>
                            </b-button>
                        </div>
                    </b-form-group>
                </div>
            </div>

            <b-card class="mb-4" id="studentsTableTour">
                <!-- Load Table -->
                <b-skeleton-wrapper :loading="loading">

                <!-- Loading -->
                <template #loading>
                    <b-skeleton-table
                        :rows="lastResultsCount"
                        :columns="6"
                        :table-props="{ bordered: true, striped: false }"
                    >
                    </b-skeleton-table>
                </template>

                <div class="alert alert-info d-flex justify-content-between align-items-center" v-if="selected.length > 0">

                    <div>
                        Você está selecionando <b>{{ selected.length }}</b> alunos.
                    </div>

                    <div>
                        <b-dropdown text="Ações" variant="primary" right>
                            <b-dropdown-item @click="selectCreditBatch" :disabled="! credit">Alterar Créditos</b-dropdown-item>
                        </b-dropdown>
                    </div>

                </div>

                <!-- Table -->
                <b-table
                    id="studentTable"
                    ref="selectableTable"
                    :items="table"
                    :fields="fields"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    @sort-changed="changeSortable"
                    @row-selected="onRowSelected"
                    select-mode="multi"
                    :selectable="true"
                    empty-text="Não encontramos nenhum resultado na busca :("
                    class="bg-white mb-0"
                    stacked="md"
                    :sticky-header="true"
                    show-empty
                    no-local-sorting
                    bordered
                    hover>

                    <template v-slot:head(selected)="data">
                        <b-form-checkbox @input="inputSelectAll($event)"></b-form-checkbox>
                    </template>

                    <template #cell(selected)="{ rowSelected, index}">
                        <b-form-checkbox
                            v-model="rowSelected"
                            @input="inputSelect($event, index)"
                        ></b-form-checkbox>
                    </template>

                    <template v-slot:cell(matriculation)="row">
                        <span v-if="row.item.matriculation" class="">
                            <b>{{ row.item.matriculation }}</b>
                        </span>
                        <span v-else>
                            ---
                        </span>
                    </template>

                    <template v-slot:cell(name)="row">
                        <span v-b-tooltip.hover :title="row.item.name">
                            {{ row.item.name | truncate(20) }}
                        </span>
                    </template>

                    <template v-slot:cell(email)="row">
                        <span v-b-tooltip.hover :title="row.item.email">
                            {{ row.item.email }}
                        </span>
                    </template>

                    <template v-slot:cell(essays_count)="row">
                        <span v-if="row.item.essays_count" class="">
                            <b>{{ row.item.essays_count }}</b>
                        </span>
                        <span v-else>
                            ---
                        </span>
                    </template>

                    <template v-slot:cell(birth)="row">
                        {{ row.item.birth | moment('DD/MM/YYYY') }}
                    </template>

                    <template v-slot:cell(genre)="row">
                        <span v-if="row.item.genre === 'M'">
                            Masculino
                        </span>
                        <span v-if="row.item.genre === 'F'">
                            Feminino
                        </span>
                        <span v-if="row.item.genre === 'O'">
                            Outro
                        </span>
                    </template>

                    <template v-slot:cell(groups)="row">

                        <a class="mr-1" href="javascript:void(1);" @click="changeGroup(row.item)" v-b-tooltip.hover title="Alterar Turma(s)">
                            <i class="fas fa-edit"></i>
                        </a>

                        <span v-for="item in row.item.groups" :key="item.id" class="mr-2">
                            <span v-if="item.name">
                                {{ item.name }}
                            </span>
                            <span v-else>
                                ---
                            </span>
                        </span>

                    </template>

                    <template v-slot:cell(created_at)="row">
                        <span v-b-tooltip.hover :title="row.item.created_at | moment('DD/MM/YYYY HH:mm')">
                            {{ row.item.created_at | moment('from', 'now') }}
                        </span>
                    </template>

                    <template v-slot:cell(credits)="row">
                        <credits :student="row.item" @updated="load" />
                    </template>

                    <template v-slot:cell(blockeds)="row">
                        <blockeds :student="row.item" @updated="load" />
                    </template>

                    <template v-slot:cell(integration)="row">
                        <span :class="getStudentIntegration(row.item) === '---'? '' : 'py-1 px-2 rounded-pill bg-primary text-white'">
                            {{ getStudentIntegration(row.item) }}
                        </span>
                    </template>

                    <template v-slot:cell(actions)="row">
                        <div class="text-center">

                            <!-- Details -->
                            <a href="javascript:void(1)" @click="showDetail(row.item)" v-b-tooltip.hover title="Detalhes do Aluno">
                                <i class="fas fa-eye"></i>
                            </a>

                        </div>
                    </template>

                </b-table>
            </b-skeleton-wrapper>
            </b-card>

            <!-- Paginate -->
            <div class="d-flex gap-2 justify-content-between align-items-center">

                <b-pagination
                    v-model="currentPage"
                    :total-rows="total"
                    :per-page="perPage"
                    @change="changePagination"
                />
                <b-form-group class="w-auto" label="Por página:" label-cols="6" label-size="sm">
                    
                    <b-form-select size="sm" v-model="perPage" :options="options">
                        
                    </b-form-select>
                </b-form-group>
            </div>

            <!-- Results -->
            <div class="mb-4">
                {{ total }} resultados encontrados.
            </div>

        </div>

        <!-- Show -->
        <show @load="load" :matriculation="matriculation" :genre-advanced="genreAdvanced"></show>

        <!-- Change Groups -->
        <change-groups :groups-options="groups" @updated="load"></change-groups>

        <!-- Create -->
        <create :groups-options="groups" :matriculation="matriculation" :credit="credit" @created="load"></create>

        <!-- Import Many -->
        <import :groups-options="groups" :matriculation="matriculation" @imported="load"></import>

        <!-- Export Student Modal -->
        <export-student-modal></export-student-modal>

        <!-- Edit Credit Batch -->
        <b-modal
            id="editCreditBatch"
            title="Editar Créditos"
            centered
            hide-footer
        >
            <b-overlay :show="loadingCredit" rounded="sm">

                <div class="alert alert-info d-flex justify-content-between align-items-center">

                    <div>
                        Você está selecionando <b>{{ selected.length }}</b> alunos.
                    </div>

                </div>

                <!-- Field -->
                <b-form-group
                    label="Modo de Alteração"
                    description="Você deseja sobrescrever ou incrementar/decrementar os créditos dos alunos selecionados ?">

                    <!-- Input -->
                    <b-form-radio v-model="formCreditBatch.mode" name="mode" value="inc_or_dec">
                        Quero que os créditos sejam incrementados/decrementados de acordo com a quantidade que os alunos já possuem.
                    </b-form-radio>
                    <b-form-radio v-model="formCreditBatch.mode" name="mode" value="overwrite">
                        Quero que os créditos sejam sobrescritos dos alunos selecionados.
                    </b-form-radio>

                    <!-- Error -->
                    <has-errors :errors="errors" name="mode" />
                </b-form-group>

                <!-- Field -->
                <b-form-group
                    label="Qtd. de Créditos">

                    <!-- Input -->
                    <b-form-input
                        type="number"
                        :min="0"
                        v-model="formCreditBatch.qtd"
                        :state="hasErrors('qtd', errors)"
                    ></b-form-input>

                    <!-- Error -->
                    <has-errors :errors="errors" name="qtd" />
                </b-form-group>

                <!-- Field -->
                <b-form-group
                    label="Data de Vencimento">

                    <!-- Input -->
                    <b-form-datepicker
                        v-model="formCreditBatch.due_date"
                        label-no-date-selected="Nenhuma data selecionada ..."
                        locale="pt-BR">
                    </b-form-datepicker>

                    <!-- Error -->
                    <has-errors :errors="errors" name="due_date" />
                </b-form-group>

                <b-form-group>
                    <b-button type="button" variant="primary" @click="updateCreditBatch" :disabled="loadingCredit">
                        Editar Créditos
                    </b-button>
                </b-form-group>
            </b-overlay>
        </b-modal>
    </div>
</template>

<script>
import Show from './Show'
import ChangeGroups from "./ChangeGroups";
import Create from "./Create";
import Import from "./Import"
import Credits from "./Credits";
import Blockeds from "./Blockeds";
import ExportStudentModal from "./ExportStudentModal";
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import StudentsPageTour from './StudentsPageTour.vue';

export default {
    components: {
        Show,
        ChangeGroups,
        Create,
        Import,
        Credits,
        Blockeds,
        ExportStudentModal,
        DateRangePicker,
        StudentsPageTour,
    },
    props: ['endpointIndex', 'endpointSignature', 'groups', 'credit', 'matriculation', 'genreAdvanced', 'limitStudents','blockedStudents', 'countStudents', 'integrationStripe', 'hasIntegration'],
    data() {
        return {
            loading: false,
            loadingCredit: false,
            table: [],
            perPage: null,
            currentPage: 1,
            total: 0,
            sortBy: 'name',
            sortDesc: false,
            fields: [],
            filter: {
                matriculation: null,
                name: null,
                email: null,
                phone: null,
                groups: [],
                blockeds: null,
                dueDate: {
                    startDate: null,
                    endDate: null
                }
            },
            options: [
                {value: 10, text: '10' },
                {value: 20 , text: '20' },
                {value: 50 , text: '50' },
                {value: 100 , text: '100' },
            ],
            lastResultsCount: 5,
            blockeds: [
                {
                    id: 'active',
                    name: 'Somente os Ativos'
                },
                {
                    id: 'blockeds',
                    name: 'Somente os Bloqueados'
                },
            ],
            formCreditBatch: {
                mode: null,
                qtd: null,
                due_date: null
            },
            errors: {},
            selected: [],
            localeData: {
                direction: 'ltr',
                format: 'dd/mm/yyyy',
                separator: ' - ',
                applyLabel: 'Aplicar',
                cancelLabel: 'Cancelar',
                weekLabel: 'W',
                customRangeLabel: 'Período Personalizado',
                daysOfWeek: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
                monthNames: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
                firstDay: 1
            },
            showTour: false,
        }
    },
    created() {
        if (this.credit) {
            this.fields = [
                { key: 'selected' },
                { key: 'name', label: 'Nome', sortable: true },
                { key: 'email', label: 'Email', sortable: true },
                { key: 'essays_count', label: 'Nº Redações Enviadas', sortable: true },
                { key: 'groups', label: 'Turma(s)'},
                { key: 'created_at', label: 'Entrou', sortable: true },
                { key: 'credits', label: 'Créditos'},
                { key: 'blockeds', label: 'Bloqueado ?'},
                { key: 'actions', label: '' }
            ]
        } else {
            this.fields = [
                { key: 'selected' },
                { key: 'name', label: 'Nome', sortable: true },
                { key: 'email', label: 'Email', sortable: true },
                { key: 'essays_count', label: 'Nº Redações Enviadas', sortable: true },
                { key: 'groups', label: 'Turma(s)'},
                { key: 'created_at', label: 'Entrou', sortable: true },
                { key: 'blockeds', label: 'Bloqueado ?'},        
                { key: 'actions', label: '' }
            ]
        }

        if (this.matriculation) {
            this.fields.splice(1, 0, {
                key: 'matriculation', label: 'Matrícula', sortable: true
            })

            this.fields.join();
        }
        if (this.hasIntegration){
            this.fields.splice((this.fields.length - 1), 0, {
                key: 'integration', label: 'Integração'
            })

            this.fields.join(); 
        }

        this.load()

    },
    watch: {
        'filter.matriculation': async function (value) {
            this.filter.matriculation = await value;
            this.currentPage = 1
            await this.load()
        },
        'perPage': async function (value) {
            this.perPage = await value;
            this.currentPage = 1
            await this.load()
        },
        'filter.name': async function (value) {
            this.filter.name = await value;
            this.currentPage = 1
            await this.load()
        },
        'filter.email': async function (value) {
            this.filter.email = await value;
            this.currentPage = 1
            await this.load()
        },
        'filter.phone': async function (value) {
            this.filter.phone = await value;
            this.currentPage = 1
            await this.load()
        },
        'filter.groups': async function (value) {
            this.filter.groups = await value;
            this.currentPage = 1
            await this.load()
        },
        'filter.blockeds': async function (value) {
            this.filter.blockeds = await value;
            this.currentPage = 1
            await this.load()
        },
        'filter.dueDate': async function (value) {
            this.filter.dueDate = await value;
            this.currentPage = 1
            await this.load()
        }
    },
    methods: {

        load() {
            this.loading = true;
            axios.get(this.endpointIndex, {
                params: {
                    matriculation: this.filter.matriculation,
                    name: this.filter.name,
                    email: this.filter.email,
                    phone: this.filter.phone,
                    groups: this.filter.groups,
                    blockeds: this.filter.blockeds ? this.filter.blockeds.id : null,
                    dueDate: this.filter.dueDate,
                    page: this.currentPage,
                    limit: this.perPage,
                    sortBy: this.sortBy,
                    sortDesc: this.sortDesc ? 'desc': 'asc'
                }
            })
                .then((result) => {
                    const response = result.data.data;

                    this.table = response.students.data
                    this.currentPage = response.students.current_page
                    this.perPage = response.students.per_page
                    this.total = response.students.total

                    this.lastResultsCount = response.students.data.length

                })
                .finally(() => this.loading = false)
        },

        async changePagination(page) {
            this.currentPage = await page;
            this.load()
        },

        async changeSortable(context) {
            this.sortBy = await context.sortBy;
            this.sortDesc = await context.sortDesc
            this.load()
        },

        selectGroupLabel({ code, name}) {
            return code + ' - ' + name
        },

        editStudentGroups(student) {
            this.$root.$emit('editStudentGroups', student)
        },

        showDetail(student) {
            this.$root.$emit('studentShowDetail', student)
        },

        changeGroup(student) {
            this.$root.$emit('updateStudentGroups', student)
        },

        createStudent() {
            this.$root.$emit('createStudent')
        },

        importMany() {
            this.$root.$emit('importMany')
        },

        onRowSelected(items) {
            this.selected = items;
        },

        inputSelect(event, key) {
            if (event) {
                this.$refs.selectableTable.selectRow(key)
            } else {
                this.$refs.selectableTable.unselectRow(key)
            }
        },

        inputSelectAll(event) {
            if (event) {
                this.$refs.selectableTable.selectAllRows()
            } else {
                this.$refs.selectableTable.clearSelected();
            }
        },

        selectCreditBatch() {
            this.formCreditBatch = {
                mode: null,
                qtd: null,
                due_date: null
            };

            this.$bvModal.show('editCreditBatch')
        },

        updateCreditBatch() {
            this.loadingCredit = true;
            axios.put('/teacher/students/update-credit-batch', {
                ...this.formCreditBatch,
                selected: this.selected.map((sel) => sel.id)
            })
                .then((result) => {

                    // Load
                    this.load();

                    this.selected = [];

                    this.errors = {};

                    // Message
                    this.$toast.success('Créditos foram alterados com sucesso !');

                    // Close Modal
                    this.$bvModal.hide('editCreditBatch')
                })
                .catch((errors) => {
                    // Check Errors
                    this.errors = this.setErrors(errors)
                })
                .finally(() => this.loadingCredit = false)
        },

        openExportStudent() {
            this.$root.$emit('openExportStudentModal');
        },


        clearDueDate() {
            this.filter.dueDate = {
                startDate: null,
                endDate: null
            };

            this.load();
        },

        getStudentIntegration(student){
            let integration = '---'
            if(student.groups.length > 0){
                const groups = student.groups;

                groups.forEach(group => {
                    if(group.pivot && group.pivot.integration){
                        integration = String(group.pivot.integration);
                    }
                })
            }

            return integration;
        }

    }
}
</script>

<style scoped>

</style>
